// import "@babel/polyfill";
import Vue from "vue";
import "./plugins/axios";
import "./plugins/vuetify";
import "./plugins/veeValidate";
import "./plugins/vueMoment";
import "./plugins/viewer";
import "./plugins/vueLazyLoad";
import "./plugins/vueNavigatorOnline";
import "./registerServiceWorker";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import filters from "@/util/filters";
import "nprogress/nprogress.css";
// reset localStorage
// import Util from "@/util";
// Util.ls.clear();

for (let name in filters) {
  Vue.filter(name, filters[name]);
}

Vue.config.productionTip = false;
Vue.config.performance = true;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
